import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-photoshop-zh-cn/uxp-photoshop-zh-cn/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="uxpplugininfo" id="uxpplugininfo"></a>
    <h1 {...{
      "id": "uxpplugininfo"
    }}>{`UxpPluginInfo`}</h1>
    <a name="uxpplugininfo-id" id="uxpplugininfo-id"></a>
    <h2 {...{
      "id": "id--string"
    }}>{`id ⇒ `}<inlineCode parentName="h2">{`String`}</inlineCode></h2>
    <p>{`Get plugin id`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`String`}</inlineCode>{`  `}</p>
    <a name="uxpplugininfo-version" id="uxpplugininfo-version"></a>
    <h2 {...{
      "id": "version--string"
    }}>{`version ⇒ `}<inlineCode parentName="h2">{`String`}</inlineCode></h2>
    <p>{`Get plugin version`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`String`}</inlineCode>{`  `}</p>
    <a name="uxpplugininfo-name" id="uxpplugininfo-name"></a>
    <h2 {...{
      "id": "name--string"
    }}>{`name ⇒ `}<inlineCode parentName="h2">{`String`}</inlineCode></h2>
    <p>{`Get plugin name`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`String`}</inlineCode>{`  `}</p>
    <a name="uxpplugininfo-manifest" id="uxpplugininfo-manifest"></a>
    <h2 {...{
      "id": "manifest--json"
    }}>{`manifest ⇒ `}<inlineCode parentName="h2">{`JSON`}</inlineCode></h2>
    <p>{`Get plugin manifest`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`JSON`}</inlineCode>{`  `}</p>
    <a name="uxpplugininfo-isfirstparty" id="uxpplugininfo-isfirstparty"></a>
    <h2 {...{
      "id": "isfirstparty"
    }}>{`isFirstParty()`}</h2>
    <p>{`Check if the plugin is First Party Plugin`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Boolean`}</inlineCode>{`  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      